/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import { useCallback } from 'react';

// Components
import BlocBoutonDAction from '@/components/blocks/BlocBoutonDAction/BlocBoutonDAction';
import BlocEquipe from '@/components/blocks/BlocEquipe/BlocEquipe';
import BlocFAQ from '@/components/blocks/BlocFAQ/BlocFAQ';
import BlocHero from '@/components/blocks/BlocHero/BlocHero';
import BlocListe from '@/components/blocks/BlocListe/BlocListe';
import BlocListeMedia from '@/components/blocks/BlocListeMedia/BlocListeMedia';
import BlocMarques from '@/components/blocks/BlocMarques/BlocMarques';
import BlocMiseEnAvantCommande from '@/components/blocks/BlocMiseEnAvantCommande/BlocMiseEnAvantCommande';
import BlocReassurance from '@/components/blocks/BlocReassurance/BlocReassurance';
import BlocTexte from '@/components/blocks/BlocTexte/BlocTexte';
import BlocTexteMedia from '@/components/blocks/BlocTexteMedia/BlocTexteMedia';
import BlocListeCards from '@/components/blocks/BlocListeCards/BlocListeCards';
import SectionEnTete from '@/components/blocks/SectionEnTete/SectionEnTete';
import SectionAvis from '@/components/blocks/SectionAvis/SectionAvis';
import SectionActualite from '@/components/blocks/SectionActualite/SectionActualite';
import SectionAvantages from './SectionAvantages/SectionAvantages';
import SectionPourQui from './SectionPourQui/SectionPourQui';
import SectionAvantages2 from './SectionAvantages2/SectionAvantages2';
import SectionRecyclage from './SectionRecyclage/SectionRecyclage';

// Other
import { type BlockType } from '../../services/blocksSchema';

interface PageBlocksProps {
  blocks: BlockType[],
}

export function PageBlocks({
  blocks,
}: PageBlocksProps) {
  const renderBlock = useCallback((block: BlockType) => {
    switch (block.__component) {
    case 'blocks.bloc-bouton-d-action':
      return <BlocBoutonDAction {...block} />;
    case 'blocks.bloc-equipe':
      return <BlocEquipe {...block} />;
    case 'blocks.bloc-faq':
      return <BlocFAQ {...block} />;
    case 'blocks.bloc-hero':
      return <BlocHero {...block} />;
    case 'blocks.bloc-liste':
      return <BlocListe {...block} />;
    case 'blocks.bloc-liste-and-media':
      return <BlocListeMedia {...block} />;
    case 'blocks.bloc-marques':
      return <BlocMarques {...block} />;
    case 'blocks.bloc-mise-en-avant-commande':
      return <BlocMiseEnAvantCommande {...block} />;
    case 'blocks.bloc-reassurance':
      return <BlocReassurance {...block} />;
    case 'blocks.bloc-texte':
      return <BlocTexte {...block} />;
    case 'blocks.bloc-texte-and-media':
      return <BlocTexteMedia {...block} />;
    case 'blocks.bloc-liste-cards':
      return <BlocListeCards {...block} />;
    case 'home.section-en-tete':
      return <SectionEnTete {...block} />;
    case 'home.section-avis':
      return <SectionAvis />;
    case 'home.section-actualite':
      return <SectionActualite {...block} />;
    case 'home.section-avantages':
      return <SectionAvantages {...block} />;
    case 'sections.section-pour-qui':
      return <SectionPourQui {...block} />;
    case 'sections.section-avantages-pneumaclic-2':
      return <SectionAvantages2 {...block} />;
    case 'sections.section-recyclage':
      return <SectionRecyclage {...block} />;
    default: return <div />;
    }
  }, []);

  return (
    <>
      {
        blocks.map((block) => (
          <div key={`${block.__component}-${block.id}`}>
            {renderBlock(block)}
          </div>
        ))
      }
    </>
  );
}